//////////////////////////// helper functions of page 3 ////////////////////////////
export function tableLegendHelper(value) {

    if (value > 90) {
        return { label: 'عالی', color: '#008B45' }
    }

    if (value > 80 && value < 90) {
        return { label: 'بسیار خوب', color: '#159900' }
    }

    if (value > 70 && value < 80) {
        return { label: 'خوب رو به بالا', color: '#19B200' }
    }

    if (value > 60 && value < 70) {
        return { label: 'خوب', color: '#9AD000' }
    }

    if (value > 50 && value < 60) {
        return { label: 'متوسط رو به بالا', color: '#F2F600' }
    }

    if (value > 40 && value < 50) {
        return { label: 'متوسط', color: '#FFCB12' }
    }

    if (value > 30 && value < 40) {
        return { label: 'ضعیف رو به بالا', color: '#E98C00' }
    }

    if (value > 20 && value < 30) {
        return { label: 'ضعیف', color: '#EE4700' }
    }

    if (value < 20) {
        return { label: 'بسیار ضعیف', color: '#FF0000' }
    }
}

//////////////////////////// helper functions of page 7 ////////////////////////////

export function tableYieldGapLegendHelper(value, parametersYieldGapContribution) {

    let range, max = value, min = value, totalArray = [...parametersYieldGapContribution[0], ...parametersYieldGapContribution[1]]

    totalArray.forEach(function (item) {
        if (item.value !== '') {
            max = Math.max(item.value, max)
        }
    })

    totalArray.forEach(function (item) {
        if (item.value !== '') {
            min = Math.min(item.value, min)
        }
    })

    range = (max - min) / 3

    if (value === max) {
        return '#F00'
    }

    if (value >= min + range * 2 && value < min + range * 3) {
        return '#FF7A00'
    }

    if (value >= min + range * 1 && value < min + range * 2) {
        return '#FBFF1E'
    }

    if (value > min && value < min + range * 1) {
        return '#8ED000'
    }

    if (value === min) {
        return '#116B09'
    }
}
